export default __webpack_public_path__ + "static/media/firma_martin.24e7c798.png";